import type { PaginationResponse } from "@type/pagination";
import { queryClient } from "@provider/query-client";
import api, { methods } from "@api";
import type { Order } from "@type/orders";
import { useSuspenseInfiniteQuery } from "@tanstack/react-query";
import { flattenPages } from "@utils";
import * as React from "react";
type OrderParams = object;

const getQueryFn = (params: OrderParams) =>
  api<PaginationResponse<Order>>({
    path: "/account/orders",
    method: methods.GET,
    params,
  });

function getQueryKey(params: OrderParams) {
  const arrayOfValues = Object.values(params || {});
  return ["orders", ...arrayOfValues];
}

export function prefetchOrders() {
  const params = {};

  queryClient.prefetchInfiniteQuery({
    queryKey: getQueryKey(params),
    queryFn: () => getQueryFn(params),
    initialPageParam: 1,
    // 30 seconds
    staleTime: 30 * 1000,
  });
}
export function useOrders() {
  const query = useSuspenseInfiniteQuery({
    queryKey: getQueryKey({}),
    queryFn: ({ pageParam }) => {
      return getQueryFn({ page: pageParam });
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const page = lastPage?.next_page_url?.split("page=")[1];
      return page ? Number(page) : undefined;
    },
  });

  const orders = React.useMemo(() => flattenPages(query.data), [query.data]);

  return { orders, ...query };
}
